import React, { useState, useRef } from 'react';

import { Divider, List, Descriptions, Modal } from 'antd';
import Button from 'app/components/Button';
import Panel from 'app/components/Layout/Panel';
import { Formik, useFormikContext } from 'formik';
import { FactoryListItem, SupplierListItem } from 'app/components/List';
import Edit from './Edit';

const SupplierAndFactory = () => {
  const formikRef = useRef(null);
  const { values, setValues } = useFormikContext();
  const { suppliers = [], factory }: any = values;
  const [edit, setEdit] = useState(false);

  const onEdit = () => {
    setEdit(true);
  };

  return (
    <Panel
      title="C) Supplier & Factory"
      extra={
        <Button type="link" onClick={onEdit}>
          Edit
        </Button>
      }
    >
      <List
        header="Supplier:"
        split={false}
        dataSource={suppliers}
        renderItem={(supplier: any) => {
          return (
            <SupplierListItem
              name={supplier.name}
              supplierId={supplier.supplierId}
              emails={[{ email: supplier.contactPersonEmail }]}
              contactPerson={supplier.contactPerson}
              address={supplier.address1 || supplier.address2}
              contactPersonPhone={[
                supplier.contactPersonPhone.code,
                supplier.contactPersonPhone.phone
              ]
                .filter((val) => !!val)
                .join(' ')}
            />
          );
        }}
      ></List>
      <List
        header="Factory:"
        split={false}
        dataSource={factory ? [factory] : []}
        renderItem={(record) => {
          return (
            <FactoryListItem
              bordered
              image={record.image}
              factoryId={record.factoryId}
              name={record.name}
              address={record.address}
            >
              <Divider />
              <Descriptions>
                <Descriptions.Item label="Contact Person #">
                  {record.contactPerson}
                </Descriptions.Item>
                <Descriptions.Item label="Contact no.">
                  {[
                    record.contactPersonPhone.code,
                    record.contactPersonPhone.phone
                  ]
                    .filter((val) => !!val)
                    .join(' ')}
                </Descriptions.Item>
                <Descriptions.Item label="Email Address">
                  {record.contactPersonEmail}
                </Descriptions.Item>
              </Descriptions>
            </FactoryListItem>
          );
        }}
      />
      <Modal
        open={edit}
        title="Supplier & Factory Information"
        width="80%"
        cancelButtonProps={{ hidden: true }}
        onOk={() => {
          formikRef.current.submitForm();
          setEdit(false);
        }}
        onCancel={() => {
          setEdit(false);
        }}
        okText="Confirm"
        bodyStyle={{
          maxHeight: 650,
          overflowY: 'auto'
        }}
      >
        <Formik
          initialValues={values}
          enableReinitialize
          onSubmit={(values) => {
            setValues(values);
          }}
        >
          {(formikProps) => {
            formikRef.current = formikProps;
            return <Edit />;
          }}
        </Formik>
      </Modal>
    </Panel>
  );
};

export default SupplierAndFactory;
